export default __webpack_public_path__ + "static/ak-cached/24h/media/Laptop.924d50ba.png";